import _concat from "./internal/_concat.js";
import _curry3 from "./internal/_curry3.js";
var adjust = _curry3(function adjust(idx, fn, list) {
    if (idx >= list.length || idx < -list.length) {
        return list;
    }
    var start = idx < 0 ? list.length : 0;
    var _idx = start + idx;
    var _list = _concat(list);
    _list[_idx] = fn(list[_idx]);
    return _list;
});
export default adjust;
